import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" id="about" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <div className="text-center mb-12" data-id="element-18">
          <h2 className="text-5xl md:text-6xl font-black uppercase mb-4" data-id="element-19">
            <span className="bg-clip-text text-transparent bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-500" data-id="element-20">
              About Mike's Pro Detail
            </span>
          </h2>
          <div className="h-1 w-24 bg-red-600 mx-auto rounded-full shadow-[0_0_10px_rgba(220,38,38,0.8)]" data-id="element-21" />
        </div>

        <motion.div initial={{
        y: 30,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-zinc-900/40 rounded-xl border border-zinc-800 p-8 space-y-4" data-id="element-22">
          <p className="text-gray-300 text-lg leading-relaxed" data-id="element-23">
            Mike's Pro Detail is a trusted mobile auto detailing service proudly
            serving Los Angeles, Ventura County, and surrounding areas including
            Agoura Hills, Thousand Oaks, Calabasas, Woodland Hills, and Westlake
            Village. We bring professional-grade detailing directly to your
            home, office, or anywhere convenient for you.
          </p>
          <p className="text-gray-300 text-lg leading-relaxed" data-id="element-24">
            With years of hands-on experience and a commitment to perfection,
            owner Mike personally handles every detail — from deep interior
            cleaning and seat shampooing to clay bar treatments and hybrid
            ceramic wax protection. We use only premium, eco-friendly products
            to deliver showroom-quality results every time.
          </p>
          <p className="text-gray-300 text-lg leading-relaxed" data-id="element-25">
            Rated 5 stars on both Google and Yelp, Mike's Pro Detail has built a
            loyal customer base through honest pricing, reliable scheduling, and
            results that speak for themselves. Whether your car needs a quick
            wash and wax or a complete full detail, we treat every vehicle like
            it's our own.
          </p>
        </motion.div>
      </div>
    </section>;
}